// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"84":"9a7a7643","285":"7e510750","440":"64a84af2","672":"94036134","703":"d736d7cd","722":"9b4d4297","973":"08250817"}[chunkId] + ".chunk.js";
};